export default __webpack_public_path__ + "static/media/shoe_1.99a65221.jpg";